import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'dateFormat', pure: false })
export class DateFormatPipe implements PipeTransform {
  // For date format composition, see : https://moment.github.io/luxon/#/formatting?id=table-of-tokens
  public transform(value: Date | DateTime | string, dateFormat: string): string {
    if (typeof value === 'string') {
      return DateTime.fromISO(value).toFormat(dateFormat);
    }
    if (value instanceof Date) {
      return DateTime.fromJSDate(value).toFormat(dateFormat);
    }
    if (value instanceof DateTime) {
      return value.toFormat(dateFormat);
    }

    return '';
  }
}
